import React from 'react';

import { Modal } from '@core/Modal';
import type { ModalProps } from '@core/Modal';

export type Props = ModalProps & {
  classes?: { dialog?: string };
  /**
   * If true, adds data-testid="scroll-container" to the dialog element.
   * Used by Dialog component to maintain backwards compatibility with web repo.
   * FullscreenDialog doesn't need this as it uses StickyScroll which provides the testid.
   * @internal
   */
  enableScrollContainerTestId?: boolean;
};

const BaseDialog = React.forwardRef(function BaseDialog(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const {
    children,
    classes,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    enableScrollContainerTestId,
    role = 'dialog',
    ...modalProps
  } = props;

  return (
    <Modal ref={ref} {...modalProps}>
      <div
        aria-modal
        aria-describedby={ariaDescribedBy}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        className={classes?.dialog}
        {...(enableScrollContainerTestId && {
          'data-testid': 'scroll-container',
        })}
        role={role}
      >
        {children}
      </div>
    </Modal>
  );
});

export default BaseDialog;
